/*
 * @Author: panweikang
 * @Date: 2024-01-06 14:23:36
 * @LastEditTime: 2024-07-23 13:35:20
 * @Description:
 */
import request from '../utils/request'

/*
获取用户信息 openid
code=${params.code}&openId=${shareOpenId} 
openid:分享者的
*/
export function getUserInfoApi(params = {}) {
  return request('GET', '/openAPI/region/user-empower', params)
}

// 大区 话题
export function getRegionListApi(params = {}) {
  return request('GET', '/openAPI/region/get-region-list', params)
}

// 验证手机 openid
export function checkPhoneApi(params = {}) {
  return request('GET', '/openAPI/region/check-user-mobile', params)
}

/*
发送验证码
{
    "openId": "aaabbbxxx",
    "mobile": "15900983463"
}
*/
export function sendVerifyCodeApi(params = {}) {
  return request('POST', '/openAPI/sms/send-verify-code', params)
}

/*
校验验证码
{
    "openId": "aaabbbxxx",
    "mobile": "15900983463",
    "code": "835337"
}
*/
export function checkVerifyCodeApi(params = {}) {
  return request('POST', '/openAPI/sms/check-verify-code', params)
}

/*
验证用户剩余锦囊数
openId
*/
export function checkArmouryNumberApi(params = {}) {
  return request('GET', '/openAPI/region/check-armoury-number', params)
}

/*
扣除锦囊
{
  "openId": "aaabbbxxx",
  "topicId": ""
}
*/
export function deductArmouryNumberApi(params = {}) {
  return request('POST', '/openAPI/region/deduct-armoury-number', params)
}

/*
发送报告
{
  "openId": "aaabbbxxx",
  "email": "11265@qq.com",
  "topicId": ""  不填就是全部
}
*/
// 发送单独报告
export function sendEmailByReportApi(params = {}) {
  return request('POST', '/openAPI/region/send-email-by-report', params)
}

// 报告邮件打包下载
export function emailReportPackageDownloadApi(params = {}) {
  return request('POST', '/openAPI/region/email-report-package-download', params)
}


//邀请记录 openId
export function getInviteListApi(params = {}) {
  return request('GET', '/openAPI/region/get-invite-list', params)
}

//报告列表 openId
export function getPayReportListApi(params = {}) {
  return request('GET', '/openAPI/region/get-pay-report-list', params)
}


/*
验证是否有权限查看报告
{
  "openId": "o5u_6sl6MooG9dj0xGDC_zqwWExc",
  "topicId": "m66stley77"
}
*/
export function checkUserViewReportApi(params = {}) {
  return request('POST', '/openAPI/region/check-user-view_report', params)
}

// 获取jssdk ticket  url
export function jsConfigApi(params = {}) {
  return request('GET', '/openAPI/wms/wx/jsConfig', params)
}

// 付费分享 详情
export function getSharePayDetailApi(params = {}) {
  return request('GET', '/openAPI/region/get-share-pay-detail', params)
}

// 拉起支付
/*
{
    "openId": "o5u_6sl6MooG9dj0xGDC_zqwWExc",
    "topicIds": [
        "54ph2qv7t7"
    ],
    "price": 10
}
*/
export function wxJsapiPayApi(params = {}) {
  return request('POST', '/openAPI/region/wx-jsapi-pay', params)
}

// 滚动弹幕消息
export function getBarrageMessageApi() {
  return request('GET', '/openAPI/region/get-barrage-message')
}

//更新用户邮箱
export function updateUserEmailApi(params = {}) {
  return request('POST', '/openAPI/region/update-user-email', params)
}

//参团对应信息
export function getTeamWorkInfoApi(params = {}) {
  return request('GET', '/openAPI/region/get-team-work-info', params)
}

// 拼团享优惠详情-待成团列表&成团记录信息
export function getTeamWorkListApi(params = {}) {
  return request('GET', '/openAPI/region/get-team-work-list', params)
}

//查询参团对应详情接口
export function getTeamWorkDetailApi(params = {}) {
  return request('GET', '/openAPI/region/get-team-work-detail', params)
}
// http://localhost:8130?openId=o5u_6sl6MooG9dj0xGDC_zqwWExc&clusterId=1748821044753141760


export function regionOssPolicy(params = {}) {
  return request('GET', '/openAPI/region/oss/policy', params)
}
// http://localhost:8130/openAPI/region/oss/policy?openId=o5u_6sgk2HDP_ntv97w57xjMeJ0s

// 快速提交拼团
export function submitFastTeamApi(params = {}) {
  return request('POST', '/openAPI/region/submit-fast-team', params)
}
